import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from "./App";

import DocumentMeta from 'react-document-meta';

const meta = {
    title: 'Brandgamification - etermax',
    description: 'Brandgamification - etermax',
    canonical: 'https://etermax.com/brandgamification/',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'brandgamification,contact,etermax,services'
        }
    }
};

ReactDOM.render(
<DocumentMeta {...meta}>
    <App/>
</DocumentMeta>
    ,
  document.getElementById('root')
);

reportWebVitals();
